import { roles } from '@nxsys/store/constants';
import CISStateOfEarningReport from '../../../modules/reports/management/listing/CISStateOfEarningReport';
import DormantWorkerReport from '../../../modules/reports/management/listing/DormantWorkerReport';
import EmploymentIntermediaryReport from '../../../modules/reports/management/listing/EmploymentIntermediaryReport';

export const managementReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/management/employment-intermediary',
    element: <EmploymentIntermediaryReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/management/earning-summary',
    element: <CISStateOfEarningReport />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/management/dormant-worker',
    element: <DormantWorkerReport />,
  },
];
